import { render, staticRenderFns } from "./ComercioExteriorEmisor.vue?vue&type=template&id=85a27f16&"
import script from "./ComercioExteriorEmisor.vue?vue&type=script&lang=js&"
export * from "./ComercioExteriorEmisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports